import { environment } from '../../environments/environment';
import { LocalizationHelper } from '../groups/shared/helpers/localization-helper';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiErrorParser {
  constructor(
    private localizationHelper: LocalizationHelper,
    private translate: TranslateService
  ) {}

  public extractErrorMessage(data: any): string {
    if (!data) {
      return this.translate.instant('error.message.unknown');
    }

    let message;

    // Scenario when the API returns an error
    const apiErrorCode = data.error?.Code ?? data.error;
    if (apiErrorCode) {
      message =
        this.localizationHelper.localizedMessageForApiErrorCode(apiErrorCode);
    } else {
      message = this.translate.instant('error.message.unknown');
    }

    // Log error to the console when in debug
    if (!environment.production) {
      console.log(JSON.stringify(data, null, 2));
    }

    return message;
  }
}
